module.exports = __webpack_public_path__ + "static/media/Million Dollar Round Table Logo.f713d554.jpeg";